import React from "react";
import { Form } from "react-bootstrap";

const InputWithLabel = ({
  label,
  type = "text",
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  error = false,
  className = "",
  labelClassName = "",
  maxLength,
  inputMode,
  pattern,
}) => {
  return (
    <Form.Group className={`mb-3 ${className}`}>
      {label ? (
        <Form.Label className={`cmn_label ${labelClassName}`.trim()}>
          {label} {required && <span className="text-danger">*</span>}
        </Form.Label>
      ) : null}
      <Form.Control
        className={`${disabled ? "disabled_input" : "cmn_input"} ${error ? "border border-danger" : ""}`}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        readOnly={disabled}
        maxLength={maxLength}
        inputMode={inputMode}
        pattern={pattern}
      />
    </Form.Group>
  );
};

export default InputWithLabel;
